import React from "react";
import { Box } from "app/material-framework/materialComponents";

export function ResizablePanelHandle({ onDrag }) {
  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: 10,
        cursor: "ew-resize",
        zIndex: 1400,
        bgcolor: "#eee",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": { bgcolor: "#ccc" },
        borderRight: "1px solid #D9D9D9",
        userSelect: "none",
        touchAction: "none",
      }}
      onMouseDown={onDrag}
    >
      <Box sx={{ width: 4, height: 40, bgcolor: "#bbb", borderRadius: 2 }} />
    </Box>
  );
}
